module.exports = __webpack_public_path__ + "img/ibm.f5adee49.png";